import {MenuModule} from './App/MenuModule';
import {VideoModule} from './App/VideoModule';
import {NestedLinksModule} from './App/NestedLinksModule';

$(document).ready((e) => {
    let menuModule = new MenuModule();
    let videoModule = new VideoModule();
    new NestedLinksModule();
});



// WEBPACK FOOTER //
// ./www/wp-content/themes/sleeping-giants/assets/scripts/src/index.js